import { getIncentiveCampaignAccumulated } from './get-incentive-campaign-accumulated-amount';

export const accumulated = {
  get: getIncentiveCampaignAccumulated,
};
